
import util from '~/assets/js/util.mjs'
import Config from '~/assets/js/config.mjs'
// import { mapMutations } from 'vuex'
// const consola = require('consola')

const getEventList = () =>
  import('~/content/evenements/events.json').then((m) => m.default || m)

export default {
  transition: 'slide-left',
  // head() {
  //   return {
  //     script: [
  //       {
  //         src: 'https://app.mailjet.com/statics/js/iframeResizer.min.js',
  //         async: true,
  //         body: true,
  //       },
  //     ],
  //   }
  // },
  async asyncData({ $content }) {
    // console.log('plop', context, context.app, context.app.data)
    // const $content = context.$content

    const contentPath = '01._home'

    const contentWorkshops = await $content(
      contentPath + '/01._workshops'
    ).fetch()

    const contentRaisonEtre = await $content(
      contentPath + '/raison-etre'
    ).fetch()

    // Section cours
    const contentClassesTitle = await $content(
      contentPath + '/02._coursReguliers/02._coursReguliers-title'
    ).fetch()
    const contentClassesContent = await $content(
      contentPath + '/02._coursReguliers/02._coursReguliers-content'
    ).fetch()
    // const contentClassesInfos = await $content(
    //   contentPath + '/02._coursReguliers/02._coursReguliers-infos'
    // ).fetch()
    // const contentClassesTarifs = await $content(
    //   contentPath + '/02._coursReguliers/02._coursReguliers-tarifs'
    // ).fetch()

    const listDescCours = await $content(contentPath + '/description-cours')
      .where({ hide: { $ne: true } })
      .sortBy('order')
      .fetch()

    const contentTeachersBioAudeAndPom = await $content(
      contentPath + '/equipe/audepom-bio'
    ).fetch()
    const contentTeachersBioAnais = await $content(
      contentPath + '/equipe/anais-bio'
    ).fetch()
    const contentTeachersBioElsa = await $content(
      contentPath + '/equipe/elsa-bio'
    ).fetch()
    const contentTeachersBioAmelieAndRomain = await $content(
      contentPath + '/equipe/amelieromain-bio'
    ).fetch()

    const contentProjects = await $content(contentPath + '/04._projets').fetch()

    const contentContact = await $content(contentPath + '/05._contact').fetch()

    const contentEvents = await $content(contentPath + '/06._events').fetch()

    // ----

    // const contentDescCoursLindyHopDeb = await $content(
    //   contentPath + '/description-cours/lindyhop-debutant'
    // ).fetch()

    // const contentDescCoursLindyHopInter = await $content(
    //   contentPath + '/description-cours/lindyhop-intermediaire'
    // ).fetch()

    // const contentDescCoursLindyHopAvancePlus = await $content(
    //   contentPath + '/description-cours/lindyhop-avance+'
    // ).fetch()

    // const contentDescCoursCharlestonSoloTousNiveaux = await $content(
    //   contentPath + '/description-cours/charlestonsolo-tous-niveaux'
    // ).fetch()

    // const contentDescCoursCharlestonInterAvance = await $content(
    //   contentPath + '/description-cours/charlestonsolo-inter-avance'
    // ).fetch()

    // ----

    const contentNew1 = await $content(contentPath + '/alert-new1').fetch()
    const contentNew2 = await $content(contentPath + '/alert-new2').fetch()

    // const contentAlertMecanikaSwing = await $content(
    //   contentPath + '/alert-mecanikaswing'
    // ).fetch()

    // const contentAlertBlaBlaSwing = await $content(
    //   contentPath + '/alert-blablaswing'
    // ).fetch()
    // fcl

    const fullEventList = await getEventList()

    const eventList = []
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)

    // const dontShowAfter = new Date()
    // dontShowAfter.setMonth(today.getMonth() + 3)

    fullEventList.forEach((event) => {
      //---- prepare data
      event.date = new Date(event.date)

      if (event.expire_date) {
        event.expire_date = new Date(event.expire_date)
      }

      let expire_date = event.expire_date || event.date

      if (event.date.getHours() == 1) {
        event.date.setHours(23)
        event.date.setMinutes(59)
      }
      if (event.registration_open)
        event.registration_open = new Date(event.registration_open)
      //---- eo prepare data

      if (
        expire_date >= yesterday
        // && expire_date < dontShowAfter
      ) {
        eventList.push(event)
      }
    })

    eventList.sort((a, b) => {
      if (a.date > b.date) {
        return 1
      }
      if (a.date < b.date) {
        return -1
      }
      // a must be equal to b
      return 0
    })

    return {
      contentRaisonEtre,
      contentWorkshops,
      contentClassesTitle,
      contentClassesContent,
      // contentClassesInfos,
      // contentClassesTarifs,
      listDescCours,
      contentTeachersBioAudeAndPom,
      contentTeachersBioAnais,
      contentTeachersBioElsa,
      contentTeachersBioAmelieAndRomain,
      contentProjects,
      contentContact,
      contentEvents,
      contentNew2,
      contentNew1,
      // contentAlertMecanikaSwing,
      // contentAlertBlaBlaSwing,
      eventList,
      fullEventList,
    }
  },
  data() {
    const registrationLink = Config.REGISTRATION_LINK
    // const registrationLinkAtelierThematique =
    //   Config.REGISTRATION_LINK_ATELIER_THEMATIQUE

    const timetableAllDays = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi'].map(
      (str, index) => ({ name: str, id: index })
    )

    const timetableMidday = [
      // {
      //   name: 'Session thématique',
      //   type: 'thematique',
      //   desc: 'Module de 3 à 6 semaines',
      //   link: {
      //     title: 'voir ci-dessous',
      //     url: '#session-thematique',
      //   },
      //   day: 'Mardi',
      //   place: "La Baj'Art",
      //   level: '',
      //   start: {
      //     hour: 12,
      //     min: 30,
      //   },
      //   end: {
      //     hour: 13,
      //     min: 30,
      //   },
      // },
      {
        name: 'Lindy Hop Switch',
        teacher: 'avec Aude',
        type: 'lindy',
        day: 'Mercredi',
        place: "La Baj'Art",
        level: 'Débutant / Intermédiaire',
        start: {
          hour: 12,
          min: 30,
        },
        end: {
          hour: 13,
          min: 30,
        },
      },
    ]

    const timetableEvening = [
      {
        name: 'Solo Jazz Vénère',
        desc: '(3 sessions de 11 cours)',
        teacher: 'avec Anaïs',
        // link: {
        //   title: 'Informations détailée ici !',
        //   url: '/cours/team-city-battle',
        // },
        day: 'Lundi',
        place: "La Baj'Art",
        type: 'solo',
        level: 'Avancé',
        start: {
          hour: 20,
          min: 30,
        },
        end: {
          hour: 22,
          min: 0,
        },
      },
      // {
      //   display: 'mobile',
      //   name: 'Atelier thématique',
      //   type: 'thematique',
      //   desc: 'Module de 3 à 6 sem.',
      //   day: 'Mardi',
      //   place: "La Baj'Art",
      //   level: '',
      //   start: {
      //     hour: 12,
      //     min: 30,
      //   },
      //   end: {
      //     hour: 13,
      //     min: 30,
      //   },
      // },
      {
        name: "Troupe Mécanika'Swing",
        day: 'Mardi',
        place: "La Baj'Art",
        type: 'team',
        level: 'Lindy Hop & Solo',
        desc: '(sur audition)',
        start: {
          hour: 18,
          min: 30,
        },
        end: {
          hour: 20,
          min: 0,
        },
      },
      {
        name: 'Compétition & performance',
        level: 'Lindy Hop & Solo',
        desc: '(ouvert à tous)',
        day: 'Mardi',
        type: 'comp',
        biweekly: true,
        start: {
          hour: 20,
          min: 15,
        },
        end: {
          hour: 21,
          min: 45,
        },
      },
      {
        display: 'mobile',
        name: 'Lindy Hop',
        type: 'lindy',
        day: 'Mercredi',
        place: "La Baj'Art",
        level: 'Débutant/Intermédiaire - Switch',
        start: {
          hour: 12,
          min: 30,
        },
        end: {
          hour: 13,
          min: 30,
        },
      },
      {
        name: 'Lindy Hop',
        day: 'Mercredi',
        place: 'École Giannone',
        type: 'lindy',
        level: 'Intermédiaire',
        teacher: 'avec Aude & Pom',
        start: {
          hour: 19,
          min: 0,
        },
        end: {
          hour: 20,
          min: 0,
        },
      },
      {
        name: 'Atelier technique',
        day: 'Mercredi',
        level: 'Intermédiaire / avancé',
        teacher: 'avec Aude & Pom',
        type: 'lindy',
        start: {
          hour: 20,
          min: 0,
        },
        end: {
          hour: 21,
          min: 0,
        },
      },
      {
        name: 'Lindy Hop',
        type: 'lindy',
        day: 'Mercredi',
        level: 'Avancé',
        teacher: 'avec Aude & Pom',
        start: {
          hour: 21,
          min: 0,
        },
        end: {
          hour: 22,
          min: 0,
        },
      },
      {
        name: 'Lindy Hop',
        type: 'lindy',
        day: 'Jeudi',
        place: 'École Giannone',
        level: 'Débutant',
        teacher: 'avec Elsa & Pom',
        start: {
          hour: 20,
          min: 0,
        },
        end: {
          hour: 21,
          min: 0,
        },
      },
      {
        name: 'Solo Charleston',
        type: 'solo',
        day: 'Jeudi',
        level: 'Débutant / Intermédiaire',
        teacher: 'avec Elsa',
        start: {
          hour: 21,
          min: 0,
        },
        end: {
          hour: 22,
          min: 0,
        },
      },
    ]

    const places = [
      {
        name: "Baj'Art",
        nameLong: "La Baj'Art",
        address: '20 rue de la Bajatière à Grenoble',
        mapLink: 'https://goo.gl/maps/bDj54sWBuD2g8fubA',
        registration: registrationLink,
        registrationText: 'Ouverture ce soir',
        price: 260,
        priceMembership: 3,
        secondClassePrice: 150,
        discountType:
          'étudiant - hors doctorant et internes, tarif solidaire - QF < 800',
        discountPrice: 200,
        startDate: 'la semaine du <b>9 septembre 2024</b> (semaine 37) ',
      },
      {
        name: 'École Giannone',
        nameLong: 'École de Danse Giannone',
        address: "14 rue Olympe de Gouges à Saint-Martin-d'Hères",
        mapLink: 'https://g.page/GiannonedanseEcoleDanseGrenoble',
        registration: 'https://edgcart.geh-tech.com',
        registrationText: 'Pré-inscription le 15 juin',
        price: 290,
        priceMembership: 10,
        secondClassePrice: 160,
        discountType: "Plus d'information le site de l'École de danse Giannone",
        discountLink: 'https://ecolededansegiannone.fr/tarifs-et-horaires/',
        startDate: '6 septembre 2023',
      },
    ]

    const projects = [
      {
        title: 'Ateliers techniques & ludiques',
        text: "Les ateliers Mécanika'Swing proposent des cours de Lindy Hop, Charleston et Solo (et plus suivant les sessions) du niveau débutant au niveau avancé. L'objectif est d'aller un peu plus loin que ce que vous pouvez voir en cours. C'est aussi pour nous l'occasion de vous rencontrer et de vous faire découvrir un couple de danseur d'ici et d'ailleurs. Ils existent depuis 2016 et se déroulent dans une salle Grenobloise.",
        img: require('~/assets/MecanikaSwing.png'),
        lazyimg: require('~/assets/lqip/MecanikaSwing.jpg'),
        links: [
          {
            type: 'page',
            title: 'Découvrir',
            url: 'ateliers/',
            internal: true,
          },
        ],
      },
      {
        title: 'Danse sociale et temps convivial',
        text: "Nous organisons de temps à autres des apéros Balboa. Quelques heures pour se retrouver autour d'une piste de danse, de musiques qui font danser les petons et de quelques grignotteries à partager.",
        img: require('~/assets/AperoBalboa.jpg'),
        lazyimg: require('~/assets/lqip/AperoBalboa.jpg'),
      },
      {
        title: 'Pour aller plus loin et travailler sur sa danse',
        text: "Au-delà des cours particuliers, du coaching personnalisé pour définir vos objectifs, accéder à vos ambitions. Un travail singulier qui peut se faire seul ou en partenariat. Nous vous proposons des sessions de 5 ou 10 séances. C'est le Coaché'Swing !",
        img: require('~/assets/CoacheSwing.png'),
        lazyimg: require('~/assets/lqip/CoacheSwing.jpg'),
      },
      {
        title: 'Projets avec des musiciens',
        text: 'De temps à autres, nous travaillons avec des musiciens sur quelques heures ou plusieurs semaines.',
        img: require('~/assets/projet-musicien.jpg'),
        lazyimg: require('~/assets/lqip/projet-musicien.jpg'),
        links: [
          {
            type: 'youtube',
            title: 'Aliocha & Oboreal',
            url: 'https://www.youtube.com/watch?v=dclnxcFAhOk&ab_channel=oboreal69',
          },
          {
            type: 'youtube',
            title: 'Les Chats Badins',
            url: 'https://www.youtube.com/watch?v=yi0DlhXQgRs&ab_channel=LesChatsBadins',
          },
        ],
      },
    ]

    return {
      isHydrated: false,
      disableNews: true,
      registrationLink,
      // registrationLinkAtelierThematique,
      nextMecanikaRegistrationOpenDate:
        Config.NEXT_MECANIKA_REGISTRATION_DATE.OPEN,
      nextMecanikaRegistrationCloseDate:
        Config.NEXT_MECANIKA_REGISTRATION_DATE.CLOSE,
      /**
       * Request jarallax to launch parallax for this page
       */
      parallax: true,
      contactEmail: util.getApsEmail(),
      contactPhone: util.getApsPhone(),
      mecanikaswingColor: util.getColor('mecanikaswing'),
      // mecanikaswingColorAlt: util.getColor('mecanikaswing-alt'),
      projects,
      places,
      // classes,
      timetableAllDays,
      timetableMidday,
      timetableEvening,
      season: util.getSeasonData(),
      previousSeason: util.getSeasonData(-1),
    }
  },
  fetch({ store }) {
    return store.dispatch('workshops/get', { store })
  },
  // head() {
  //   return {
  //     script: [
  //       {
  //         src: 'https://code.jquery.com/jquery-3.5.1.min.js',
  //       },
  //     ],
  //   }
  // },
  computed: {
    // news
    // disableNews() {
    //   return this.newsArray.reduce((a, b) => a || b, 0)
    // },
    // init
    breakpoint() {
      return this.isHydrated ? this.$vuetify.breakpoint : {} // Any constant default value would do here
    },
    isMobile() {
      return this.breakpoint.smAndDown
    },
    // mecanikaSwingRegistrationOpen: function () {
    //   return util.registrationOpen(
    //     this.nextMecanikaRegistrationOpenDate,
    //     this.nextMecanikaRegistrationCloseDate
    //   )
    // },
    // mecanikaSwingRegistrationClose: function () {
    //   return util.registrationClose(
    //     this.nextMecanikaRegistrationOpenDate,
    //     this.nextMecanikaRegistrationCloseDate
    //   )
    // },
    introTitleClass() {
      let display = 'headline'

      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          display = 'title'
          break
        case 'md':
          display = 'display-1'
          break
        case 'lg':
          display = 'display-2'
          break
        case 'xl':
          display = 'display-3'
          break
        default:
        case 'sm':
          display = 'headline'
          break
      }
      return display
    },
    introSubtitleClass() {
      let display = 'title'

      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          display = 'subtitle-1'
          break
        default:
        case 'sm':
          display = 'title'
          break
        case 'md':
          display = 'headline'
          break
        case 'lg':
          display = 'text-h4'
          break
        case 'xl':
          display = 'display-2'
          break
      }
      return display
    },
    protectedEmail() {
      return 'mailto:m&#97;i&#108;to&#58;%4Ao%68n&#46;Do&#101;&#64;&#101;&#120;&#97;%6D&#112;l&#101;&#46;%63&#111;&#109;' // + Config.APS_EMAIL
    },
    isNextEventSoon() {
      return util.dateDaysDiff(this.nextMecanikaRegistrationCloseDate) < 10
    },
  },
  mounted() {
    this.isHydrated = true
  },
  methods: {
    getLqip: util.getLqip.bind(util),
    formatDate: util.formatDate.bind(util),
    datesAreOnSameDay: util.datesAreOnSameDay.bind(util),
    /**
     *
     * @param {String} colorText
     */
    getCourseColor: function (colorText) {
      const colorMap = {
        lindy: '#ff6981',
        troupe: '#f9de4b',
        comp: '#fbc44c',
        solo: '#54ab99',
      }

      return 'color: ' + colorMap[colorText] + ';'
    },
    showRegistrationOpenDate: function (event) {
      if (!event.registration_open) {
        return false
      }
      return !util.registrationOpen(event.registration_open, event.date)
    },
    // getEventCoverImg: (img) => require('~/assets/events/' + img),
    onIntersect(entries) {
      // consola.log('onIntersect', entries, observer, isIntersecting)

      const intersecting_element = entries[0]
      if (intersecting_element.isIntersecting) {
        const id = intersecting_element.target.id

        // consola.log('onIntersect:id', id)
        this.$store.commit('navigation/setSection', id)
      }
    },
    // getTcb() {
    //   return (
    //     this.timetableEvening.find((element) => element.type == 'tcb') || {}
    //   )
    // },
  },
}
